import {
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Align } from '../dropdown.component';
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-dropdown-content',
  templateUrl: './dropdown-content.component.html',
  styleUrls: ['./dropdown-content.component.scss']
})
export class DropdownContentComponent implements OnInit {
  @HostBinding('class.app-dropdown-content-wrap') dropdownContent = true;
  @HostBinding('class.opened') @Input() opened: boolean = false;
  @HostBinding('class') get additionalClasses(): string {
    return `app-dropdown-content-${this.align} ${this.panelClass || ''}`;
  }
  @HostBinding('style.--app-dropdown-position-start.px') private positionStart!: number;
  @HostBinding('style.--app-dropdown-position-start-test.px') positionStart$: Observable<number> = new Observable<number>();
  @HostBinding('style.--app-dropdown-top.px') private positionTop!: number;
  @HostBinding('style.--app-dropdown-trigger-width.px') @Input() triggerWidth!: number;
  @HostBinding('style.--app-dropdown-width.px') @Input() width!: number;
  @Input() panelClass!: string;
  @Input() align!: Align;
  @Input() closeInput: EventEmitter<void> = new EventEmitter<void>();
  @Output() showDropdown: EventEmitter<void> = new EventEmitter<void>();
  @Output() closeDropdown: EventEmitter<void> = new EventEmitter<void>();

  // close from Esc key
  @HostListener('window:keydown', ['$event']) keyboardInput(event: KeyboardEvent) {
    if (this.opened && event.key === 'Escape') {
      this.hide();
    }
  }
  // close on resize
  @HostListener('window:resize', ['$event']) onResize() {
    if (this.opened) {
      this.hide();
    }
  }
  @HostListener('click', ['$event']) onClick(event: PointerEvent) {
    const target = event.target as HTMLElement;

    if (this.isElement(target)) {
      this.hide();
    }
  }

  constructor(
    private element: ElementRef,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit() {
    this.closeInput.subscribe(() => {
      if (this.opened) {
        this.hide();
      }
    });
  }

  // show dropdown content
  show() {
    disableBodyScroll(this.element.nativeElement);
    this.opened = true;
    this.showDropdown.emit();
  }

  // hide dropdown content
  hide() {
    this.opened = false;
    this.closeDropdown.emit();
    enableBodyScroll(this.element.nativeElement);
    clearAllBodyScrollLocks();
  }

  // append to body
  appendComponentToBody() {
    this.document.body.appendChild(this.element.nativeElement);
  }

  // set dropdown content parameters
  setParameters(params: DOMRect) {
    let direction = this.document.dir;
    if (direction === 'rtl') {
      this.positionStart = this.document.body.offsetWidth - params.left - this.triggerWidth;
    } else {
      this.positionStart = params.right - this.triggerWidth;
    }
    
    this.positionTop = params.top + params.height;
  }

  private isElement(element: HTMLElement): boolean {
    return typeof element.className === 'string' && element.className.split(' ').includes('dropdown-item');
  }
}
